export default "__VITE_ASSET__8192d9c5__"